<template>
	<!--基础的input-->
	<p class="posi-relative input-pwd-box">
		<input type="password" :id='id' :value='val' :class="classCpt" :style="styleNew" maxlength="16"
		   :placeholder="plholder" :autofocus="autofocus" @click="$emit('click')"  
		   v-on="inputListeners" />
		<template v-if="isSpanShow">		
			<img @click="removeValue($event)" class="kcsc posi-absolute" src="../../../static/img/kcsc.png"/>
			<img v-if="isShowPwd" @click="hidePwd($event)" class="yj_k posi-absolute" src="../../../static/img/yj_k.png"/>
			<img v-else @click="showPwd($event)" class="yj_g posi-absolute" src="../../../static/img/yj_g.png"/>				
		</template>
	</p>
</template>

<script>
	export default{
		inheritAttrs: false, //根元素不继承特性
		mounted(){
			let that = this;
			//如果设定了宽度
			if(this.styleCpt){ 
				this.styleNew = this.styleCpt;
			}
			if(this.placeholder){
				this.plholder = this.placeholder;
			}
		},
		props:['id','value','styleCpt','classCpt','placeholder',
			   'autofocus','readonly','maxlength','onmousewheel'],
		data(){
			return{
				styleNew:'', //input 样式
				val:'', //输入框的值
				isSpanShow:false, // 是否显示清除 和 展示密码操作
				plholder:'请输入基金交易密码',
				isShowPwd:false
			}
		},
		methods:{
			//点击清除操作
			removeValue(e){
				this.val = '' ;
				this.isSpanShow = false;
				$(e.target).siblings('input').focus(); // 获得焦点													
			},
			hidePwd(e){
				this.isShowPwd = false;
				$(e.target).siblings('input').attr('type','password');
			},
			showPwd(e){
				this.isShowPwd = true;
				$(e.target).siblings('input').attr('type','text');
			} 
		},
		computed:{
			inputListeners:function(){
				let vm = this;
				//Object.assign 将所有的对象合并为一个新对象
				return Object.assign(
					{},
					// 我们从父级添加所有的监听器
					this.$listeners,
					//然后我们添加定义监听器，或覆写一些监听器行为
					{
						// 这里确保组件配合 `v-model` 的工作
				        input: (event) => {
				        	//用户输入时
				        	vm.val = event.target.value;
				        	if( event.target.value != '' ){
				        		vm.isSpanShow = true;
				        	}else{
				        		vm.isSpanShow = false;
				        	}
				            vm.$emit('input', event.target.value)
				        },
				        //获得焦点事件
				        onfocus: () => { vm.$emit('onfocus') },
				        //失去焦点事件
				        onblur: () => { vm.$emit('onblur') },
				        //鼠标按下
				        mousedown: () => { vm.$emit('mousedown') },
				        //鼠标抬起
				        mouseup: () => { vm.$emit('mouseup') },
				        //鼠标抬起
				        onInput: () => { vm.$emit('oninput') }
					}
				)
			}
		}
	}
</script>

<style scoped lang="less">
	.input-pwd-box { 		
		input{ padding:.4rem 3.5rem .4rem 2rem; } 
		img{ top:.65rem;right:.8rem; cursor: pointer; }
		img.yj_g{ top:.95rem; }
		img.kcsc{ top:.6rem;right:2.6rem; }
	}
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/input-Pwd-bk.vue